"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeeAllLink = exports.AccordionList = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.string.link.js");
var _react = _interopRequireDefault(require("react"));
var _core = require("../../core");
var _Icon = _interopRequireDefault(require("../../core/Icon/Icon"));
var _AccordionListItem = require("../../core/List/AccordionListItem");
var _useMedia = require("../../hooks/useMedia");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_253a01gitz() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Accordion/AccordionList.tsx";
  var hash = "4fa1714cfaa6ac795d1faf0488a35eea2dd75034";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Accordion/AccordionList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 34,
          column: 60
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "1": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 71,
          column: 4
        }
      },
      "2": {
        start: {
          line: 59,
          column: 10
        },
        end: {
          line: 67,
          column: 16
        }
      },
      "3": {
        start: {
          line: 78,
          column: 53
        },
        end: {
          line: 95,
          column: 1
        }
      },
      "4": {
        start: {
          line: 79,
          column: 23
        },
        end: {
          line: 79,
          column: 34
        }
      },
      "5": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 94,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 34,
            column: 60
          },
          end: {
            line: 34,
            column: 61
          }
        },
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 41
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 58,
            column: 30
          },
          end: {
            line: 58,
            column: 31
          }
        },
        loc: {
          start: {
            line: 59,
            column: 10
          },
          end: {
            line: 67,
            column: 16
          }
        },
        line: 59
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 78,
            column: 53
          },
          end: {
            line: 78,
            column: 54
          }
        },
        loc: {
          start: {
            line: 78,
            column: 82
          },
          end: {
            line: 95,
            column: 1
          }
        },
        line: 78
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 18
          }
        }],
        line: 39
      },
      "1": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 22
          }
        }],
        line: 40
      },
      "2": {
        loc: {
          start: {
            line: 44,
            column: 7
          },
          end: {
            line: 53,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 44,
            column: 13
          }
        }, {
          start: {
            line: 44,
            column: 17
          },
          end: {
            line: 44,
            column: 21
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 52,
            column: 15
          }
        }],
        line: 44
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 11
          },
          end: {
            line: 50,
            column: 18
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 12
          },
          end: {
            line: 49,
            column: 19
          }
        }, {
          start: {
            line: 50,
            column: 14
          },
          end: {
            line: 50,
            column: 18
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 51,
            column: 11
          },
          end: {
            line: 51,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 51,
            column: 18
          },
          end: {
            line: 51,
            column: 74
          }
        }, {
          start: {
            line: 51,
            column: 77
          },
          end: {
            line: 51,
            column: 81
          }
        }],
        line: 51
      },
      "5": {
        loc: {
          start: {
            line: 55,
            column: 22
          },
          end: {
            line: 55,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 46
          },
          end: {
            line: 55,
            column: 52
          }
        }, {
          start: {
            line: 55,
            column: 55
          },
          end: {
            line: 55,
            column: 68
          }
        }],
        line: 55
      },
      "6": {
        loc: {
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 56,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 56,
            column: 49
          },
          end: {
            line: 56,
            column: 60
          }
        }, {
          start: {
            line: 56,
            column: 63
          },
          end: {
            line: 56,
            column: 75
          }
        }],
        line: 56
      },
      "7": {
        loc: {
          start: {
            line: 64,
            column: 25
          },
          end: {
            line: 64,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 56
          },
          end: {
            line: 64,
            column: 70
          }
        }, {
          start: {
            line: 64,
            column: 73
          },
          end: {
            line: 64,
            column: 94
          }
        }],
        line: 64
      },
      "8": {
        loc: {
          start: {
            line: 91,
            column: 57
          },
          end: {
            line: 91,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 68
          },
          end: {
            line: 91,
            column: 70
          }
        }, {
          start: {
            line: 91,
            column: 73
          },
          end: {
            line: 91,
            column: 75
          }
        }],
        line: 91
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4fa1714cfaa6ac795d1faf0488a35eea2dd75034"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_253a01gitz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_253a01gitz();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Component that stacks accordions ontop of each other
 * Font for heading & see-all link will update based on device used to view accordion
 * Developer can optionally pass a title to render a title on accordionList
 * Developer can optionally pass a link to render a "See all" link that directs user to another page for more information
 * If using AccordionList in a bundle sensitive application (example: Cosmos) that uses Selective Spritesheet you must import - ChevronDown16 to get the chevron to appear
 */
cov_253a01gitz().s[0]++;
var AccordionList = exports.AccordionList = function AccordionList(_ref) {
  var analyticsName = _ref.analyticsName,
    listOfAccordions = _ref.listOfAccordions,
    title = _ref.title,
    link = _ref.link,
    _ref$wrapText = _ref.wrapText,
    wrapText = _ref$wrapText === void 0 ? (cov_253a01gitz().b[0][0]++, false) : _ref$wrapText,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? (cov_253a01gitz().b[1][0]++, 'standard') : _ref$variant;
  cov_253a01gitz().f[0]++;
  cov_253a01gitz().s[1]++;
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    width: "100%"
  }, ((cov_253a01gitz().b[2][0]++, title) || (cov_253a01gitz().b[2][1]++, link)) && (cov_253a01gitz().b[2][2]++, /*#__PURE__*/_react["default"].createElement(_core.Flex, {
    justifyContent: "space-between",
    pb: 5
  }, title ? (cov_253a01gitz().b[3][0]++, /*#__PURE__*/_react["default"].createElement(_core.Text, {
    fontSize: "s2",
    fontWeight: "semibold",
    color: "neutrals90"
  }, title)) : (cov_253a01gitz().b[3][1]++, null), link ? (cov_253a01gitz().b[4][0]++, /*#__PURE__*/_react["default"].createElement(SeeAllLink, {
    link: link,
    analyticsName: analyticsName
  })) : (cov_253a01gitz().b[4][1]++, null))), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    borderRadius: variant === 'compact' ? (cov_253a01gitz().b[5][0]++, 'none') : (cov_253a01gitz().b[5][1]++, 'semiRounded'),
    backgroundColor: variant === 'compact' ? (cov_253a01gitz().b[6][0]++, 'neutrals0') : (cov_253a01gitz().b[6][1]++, 'neutrals10')
  }, listOfAccordions.map(function (item, index) {
    cov_253a01gitz().f[1]++;
    cov_253a01gitz().s[2]++;
    return /*#__PURE__*/_react["default"].createElement(_core.Box, {
      key: "item-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement(_AccordionListItem.AccordionListItem, _extends({
      analyticsName: analyticsName,
      wrapText: wrapText
      // if item.noPadding is specified, use that, if not, set if compact
      ,
      noPadding: item.noPadding !== undefined ? (cov_253a01gitz().b[7][0]++, item.noPadding) : (cov_253a01gitz().b[7][1]++, variant === 'compact')
    }, item)));
  })));
};

/**
 * Component that handles opening up a new page for more information
 * Will only appear if a link is passed through to AccordionList
 */
cov_253a01gitz().s[3]++;
var SeeAllLink = exports.SeeAllLink = function SeeAllLink(_ref2) {
  var link = _ref2.link,
    analyticsName = _ref2.analyticsName;
  cov_253a01gitz().f[2]++;
  var _ref3 = (cov_253a01gitz().s[4]++, (0, _useMedia.useDevice)()),
    isMobile = _ref3.isMobile;
  cov_253a01gitz().s[5]++;
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_core.Link, {
    href: link,
    target: "_blank",
    fontWeight: "semibold",
    fontSize: ['s0', 's0', 's2', 's2'],
    analyticsName: analyticsName,
    "aria-label": 'Select to get more information'
  }, "See all", /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "chevron-right",
    color: "brand50",
    size: isMobile ? (cov_253a01gitz().b[8][0]++, 12) : (cov_253a01gitz().b[8][1]++, 16)
  })));
};